"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _stringUtil = require("../util/string-util.js");

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var isUndeclared = function isUndeclared(pattern) {
  var result = false;
  try {
    eval(pattern);
  } catch (e) {
    if (e instanceof ReferenceError || e instanceof SyntaxError) result = true;
  }
  return result;
};

var isA = function isA(value, type) {
  return type === "null" && value === null || (typeof value === "undefined" ? "undefined" : _typeof(value)) == type;
};

var Binding = function () {
  function Binding() {
    _classCallCheck(this, Binding);
  }

  _createClass(Binding, null, [{
    key: "binds",
    value: function binds() {
      return true;
    }
  }]);

  return Binding;
}();

var NonBinding = function () {
  function NonBinding() {
    _classCallCheck(this, NonBinding);
  }

  _createClass(NonBinding, null, [{
    key: "binds",
    value: function binds() {
      return false;
    }
  }]);

  return NonBinding;
}();

var PrimitiveValue = function (_NonBinding) {
  _inherits(PrimitiveValue, _NonBinding);

  function PrimitiveValue() {
    _classCallCheck(this, PrimitiveValue);

    return _possibleConstructorReturn(this, (PrimitiveValue.__proto__ || Object.getPrototypeOf(PrimitiveValue)).apply(this, arguments));
  }

  _createClass(PrimitiveValue, null, [{
    key: "matches",
    value: function matches(value, pattern) {
      return Object.is(eval(pattern), value);
    }
  }, {
    key: "applysFor",
    value: function applysFor(pattern) {
      if (isUndeclared(pattern)) return false;
      var value = eval(pattern);
      return isA(value, "number") || isA(value, "string") || isA(value, "boolean") || isA(value, "null") || isA(value, "undefined");
    }
  }]);

  return PrimitiveValue;
}(NonBinding);

var Variable = function (_Binding) {
  _inherits(Variable, _Binding);

  function Variable() {
    _classCallCheck(this, Variable);

    return _possibleConstructorReturn(this, (Variable.__proto__ || Object.getPrototypeOf(Variable)).apply(this, arguments));
  }

  _createClass(Variable, null, [{
    key: "matches",
    value: function matches(value, pattern) {
      return true;
    }
  }, {
    key: "applysFor",
    value: function applysFor(pattern) {
      return (/^([a-z]|[A-Z]|_)(\w)*/.test(pattern) && !PrimitiveValue.applysFor(pattern) && !Class.applysFor(pattern) && !AnnonymousVariable.applysFor(pattern)
      );
    }
  }]);

  return Variable;
}(Binding);

var AnnonymousVariable = function (_NonBinding2) {
  _inherits(AnnonymousVariable, _NonBinding2);

  function AnnonymousVariable() {
    _classCallCheck(this, AnnonymousVariable);

    return _possibleConstructorReturn(this, (AnnonymousVariable.__proto__ || Object.getPrototypeOf(AnnonymousVariable)).apply(this, arguments));
  }

  _createClass(AnnonymousVariable, null, [{
    key: "matches",
    value: function matches(value, pattern) {
      return true;
    }
  }, {
    key: "applysFor",
    value: function applysFor(pattern) {
      return pattern === "_";
    }
  }]);

  return AnnonymousVariable;
}(NonBinding);

var Class = function (_Binding2) {
  _inherits(Class, _Binding2);

  function Class() {
    _classCallCheck(this, Class);

    return _possibleConstructorReturn(this, (Class.__proto__ || Object.getPrototypeOf(Class)).apply(this, arguments));
  }

  _createClass(Class, null, [{
    key: "matches",
    value: function matches(value, pattern) {
      return value instanceof eval(pattern);
    }
  }, {
    key: "applysFor",
    value: function applysFor(pattern) {
      if (isUndeclared(pattern)) return false;
      return isA(eval(pattern), 'function');
    }
  }]);

  return Class;
}(Binding);

var GenericArray = function (_Binding3) {
  _inherits(GenericArray, _Binding3);

  function GenericArray() {
    _classCallCheck(this, GenericArray);

    return _possibleConstructorReturn(this, (GenericArray.__proto__ || Object.getPrototypeOf(GenericArray)).apply(this, arguments));
  }

  _createClass(GenericArray, null, [{
    key: "matches",
    value: function matches(value, pattern) {
      return value instanceof Array && this.emptinessHolds(value);
    }
  }]);

  return GenericArray;
}(Binding);

var EmptyArray = function (_GenericArray) {
  _inherits(EmptyArray, _GenericArray);

  function EmptyArray() {
    _classCallCheck(this, EmptyArray);

    return _possibleConstructorReturn(this, (EmptyArray.__proto__ || Object.getPrototypeOf(EmptyArray)).apply(this, arguments));
  }

  _createClass(EmptyArray, null, [{
    key: "applysFor",
    value: function applysFor(pattern) {
      return pattern === "[]";
    }
  }, {
    key: "emptinessHolds",
    value: function emptinessHolds(value) {
      return value.length === 0;
    }
  }]);

  return EmptyArray;
}(GenericArray);

var NonemptyArray = function (_GenericArray2) {
  _inherits(NonemptyArray, _GenericArray2);

  function NonemptyArray() {
    _classCallCheck(this, NonemptyArray);

    return _possibleConstructorReturn(this, (NonemptyArray.__proto__ || Object.getPrototypeOf(NonemptyArray)).apply(this, arguments));
  }

  _createClass(NonemptyArray, null, [{
    key: "applysFor",
    value: function applysFor(pattern) {
      return pattern !== "[]" && (0, _stringUtil.head)(pattern) === "[" && (0, _stringUtil.last)(pattern) == "]";
    }
  }, {
    key: "emptinessHolds",
    value: function emptinessHolds(value) {
      return value.length > 0;
    }
  }]);

  return NonemptyArray;
}(GenericArray);

exports.default = [PrimitiveValue, Variable, Class, EmptyArray, NonemptyArray, AnnonymousVariable];